// extracted by mini-css-extract-plugin
export default {"container":"DocumentHeader_container__zCVk8","hide":"DocumentHeader_hide__Wr9F0","closeButton":"DocumentHeader_closeButton__BNcTX"};